import React, { useEffect } from "react";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { CLINIC } from "@/lib/data";
import { useLang } from "@/lib/i18n";

export default function Book() {
  const { t } = useLang();

  useEffect(() => {
    // Auto-trigger phone dialer
    const target = `tel:${CLINIC.altPhone.replace(/\s|-/g, "")}`;
    const timer = setTimeout(() => {
      window.location.href = target;
    }, 600);
    return () => clearTimeout(timer);
  }, []);

  const dialHref = `tel:${CLINIC.altPhone.replace(/\s|-/g, "")}`;

  return (
    <div data-testid="book-page">
      <PageHero
        eyebrow={t("book.eyebrow")}
        title={t("book.title")}
        subtitle={t("book.subtitle")}
        crumbs={[{ label: t("nav.book") || "Book" }]}
        image="https://images.unsplash.com/photo-1666214280352-db292c05fd80?w=1600&q=80"
      />
      <section className="py-20 sm:py-28">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand/10 mb-6">
            <Phone className="w-10 h-10 text-brand" strokeWidth={1.5} />
          </div>
          <h2 className="font-display text-3xl sm:text-4xl text-deep font-semibold mb-4">{t("book.callTitle")}</h2>
          <p className="text-ink-soft leading-relaxed mb-8">{t("book.callDesc")}</p>

          <a
            href={dialHref}
            className="inline-flex items-center gap-3 px-8 py-5 bg-brand text-white rounded-full font-semibold shadow-lifted hover:bg-brand-600 transition-all text-lg"
            data-testid="book-call-btn"
          >
            <Phone className="w-5 h-5" /> {CLINIC.altPhone}
            <ArrowRight className="w-5 h-5" />
          </a>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href={`tel:${CLINIC.phone}`} className="inline-flex items-center gap-2 px-6 py-3 border border-deep/15 text-deep rounded-full text-sm font-medium">
              <Phone className="w-4 h-4 text-brand" /> {CLINIC.phone}
            </a>
            <a
              href={`https://wa.me/${CLINIC.whatsapp}?text=${encodeURIComponent("Hello, I'd like to book an appointment.")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-wa text-white rounded-full text-sm font-medium"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp
            </a>
          </div>

          <div className="mt-12 text-xs text-ink-soft">
            {t("common.timings.value")} · {t("book.hint")}
          </div>
        </div>
      </section>
    </div>
  );
}
